import { getDurationFromMins } from "@b2bportal/core-utilities";
import { useI18nContext } from "@hopper-b2b/i18n";
import { removeTimezone } from "@hopper-b2b/utilities";
import dayjs from "dayjs";

interface BenchmarkFlightHookProps {
  arrival: string;
  departure: string;
  totalDurationMinutes: number;
  destination: string;
}

export const useBenchmarkFlight = ({
  arrival,
  departure,
  totalDurationMinutes,
  destination,
}: BenchmarkFlightHookProps) => {
  const { t, formatDateTime, DateTimeFormatStyle } = useI18nContext();

  const date = formatDateTime(
    dayjs(removeTimezone(departure)).toDate(),
    DateTimeFormatStyle.ShortMonthDayShortWeekday
  );

  const departureTime = formatDateTime(
    dayjs(removeTimezone(departure)).toDate(),
    DateTimeFormatStyle.ShortTime
  );

  const arrivalTime = formatDateTime(
    dayjs(removeTimezone(arrival)).toDate(),
    DateTimeFormatStyle.ShortTime
  );

  const formatDuration = ({
    days,
    hours,
    minutes,
  }: {
    days: number;
    hours: number;
    minutes: number;
  }) => {
    const units = [
      { value: days, key: t("flightDuration.days", { count: days ?? 0 }) },
      { value: hours, key: t("flightDuration.hours", { count: hours ?? 0 }) },
      {
        value: minutes,
        key: t("flightDuration.minutes", { count: minutes ?? 0 }),
      },
    ];

    const durationString = units
      .filter((unit) => unit.value)
      .map((unit) => unit.key)
      .join(" ");

    return durationString.trim();
  };

  const duration: { days: number; hours: number; minutes: number } =
    getDurationFromMins(totalDurationMinutes).reduce(
      (acc, item) => ({
        ...acc,
        [item.key]: item.value,
      }),
      { days: 0, hours: 0, minutes: 0 }
    );

  const durationString = formatDuration(duration);

  const titleInfoValues = {
    city: destination,
    date: date,
  };

  return {
    context: {
      departureTime,
      arrivalTime,
      durationString,
      titleInfoValues,
    },
  };
};
